
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1082 768"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M543.998 0c-212.945 0-384 171.055-384 384 0 157.091 94.255 293.236 230.4 352.582 0-27.927 0-59.345 6.982-87.273 6.982-31.418 48.873-209.455 48.873-209.455s-13.964-24.437-13.964-59.345c0-59.345 34.909-101.237 76.8-101.237 34.909 0 52.363 27.927 52.363 59.345 0 34.909-20.945 87.273-34.909 136.145-10.473 41.891 20.945 73.309 59.345 73.309 73.309 0 122.182-94.255 122.182-202.473 0-83.782-55.855-146.618-160.582-146.618-115.2 0-188.509 87.273-188.509 185.018 0 34.909 10.473 55.855 24.437 76.8 6.982 6.982 6.982 10.473 6.982 20.945-3.491 6.982-6.982 24.437-6.982 31.418-3.491 10.473-10.473 13.964-20.945 10.473-52.363-20.945-80.291-80.291-80.291-146.618 0-108.218 90.764-240.873 275.782-240.873 146.618 0 244.363 104.727 244.363 219.927 0 150.109-83.782 261.818-205.963 261.818-41.891 0-80.291-20.945-94.255-48.873 0 0-20.945 87.273-27.927 104.727-6.982 27.927-24.436 59.345-38.4 83.782 34.909 10.473 69.818 17.455 108.218 17.455 212.945 0 384-171.055 384-384 0-219.927-171.055-390.982-384-390.982z","fill":"currentColor"}})])
          )
        }
      }
    